import { render, staticRenderFns } from "./SnsOgpTags.vue?vue&type=template&id=55767566&"
import script from "./SnsOgpTags.vue?vue&type=script&lang=js&"
export * from "./SnsOgpTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports